import * as React from 'react'
import { BaseOverviewCount, BaseOverviewHeaderItemProps } from './BaseOverview'
import { Badge, makeStyles, mergeClasses } from '@fluentui/react-components'

const useStyles = makeStyles({
    badge: {
        width: '24px',
        maxWidth: '40px',
    },
    badge100: {
        width: '26px',
    },
    badge1_000: {
        width: '34px',
    },
    badge10_000: {
        width: '40px',
    },
})

export default function BaseOverviewCountBadge(props: BaseOverviewHeaderItemProps<any, any, any, BaseOverviewCount>) {
    const styles = useStyles()

    return (
        <Badge
            size={props.count.total >= 10_000 ? 'medium' : 'large'}
            className={mergeClasses(
                styles.badge,
                props.count.total >= 100 && styles.badge100,
                props.count.total >= 1_000 && styles.badge1_000,
                props.count.total >= 10_000 && styles.badge10_000,
            )}
        >
            {props.count.total}
        </Badge>
    )
}
